import type { Questionnaire } from '@medplum/fhirtypes'
import {
  QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION,
  VALIDATED_TOOL_TAG,
} from '#src/models/questionnaires/utils/index.ts'
import { QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL } from '#src/structureDefinitions.ts'

export const miiQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
  title: 'Michigan Incontinence Index',
  name: 'MII',
  status: 'active',
  subjectType: ['Patient'],
  meta: {
    tag: [VALIDATED_TOOL_TAG],
  },
  item: [
    {
      linkId: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
      type: 'display',
      text: 'MII PDF',
      extension: [
        {
          url: QUESTIONNAIRE_ITEM_DISPLAY_LINK_URL,
          valueString:
            'https://victoriaoceansidehealth.com/files/IncontinenceQA.pdf',
        },
      ],
    },
    {
      linkId: 'physical-activity',
      type: 'choice',
      text: '1. How often has urine leakage occurred in association with any physical activity (such as lifting, bending, sitting down, standing up, exercising, etc.)?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-physical-activity',
          display: 'Physical Activity',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-physical-activity-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-physical-activity-1',
            display: 'Rarely',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-physical-activity-2',
            display: 'Occcasionally',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-physical-activity-3',
            display: 'About half the time',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-physical-activity-4',
            display: 'Most or all of the time',
          },
        },
      ],
    },
    {
      linkId: 'lifting-light-objects',
      type: 'choice',
      text: '2. How often has lifting light objects (such as a gallon of milk) caused you to leak urine?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-lifting-light-objects',
          display: 'Lifting Light Objects',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-lifting-light-objects-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-lifting-light-objects-1',
            display: 'Rarely',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-lifting-light-objects-2',
            display: 'Occasionally',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-lifting-light-objects-3',
            display: 'About half the time',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-lifting-light-objects-4',
            display: 'Most or all of the time',
          },
        },
      ],
    },
    {
      linkId: 'walking-light-exercise',
      type: 'choice',
      text: '3. How often has walking or light exercise caused you to leak urine?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-walking-light-exercise',
          display: 'Walking or Light Exercise',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-walking-light-exercise-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-walking-light-exercise-1',
            display: 'Rarely',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-walking-light-exercise-2',
            display: 'Occasionally',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-walking-light-exercise-3',
            display: 'About half the time',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-walking-light-exercise-4',
            display: 'Most or all of the time',
          },
        },
      ],
    },
    {
      linkId: 'wait-empty-bladder',
      type: 'choice',
      text: '4. How often have you leaked urine because you could not wait to empty your bladder?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-wait-empty-bladder',
          display: 'Wait to Empty Bladder',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-wait-empty-bladder-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-wait-empty-bladder-1',
            display: 'Seldom',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-wait-empty-bladder-2',
            display: 'About once a week',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-wait-empty-bladder-3',
            display: 'About once a day',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-wait-empty-bladder-4',
            display: 'More than once a day',
          },
        },
      ],
    },
    {
      linkId: 'sudden-urge',
      type: 'choice',
      text: '5. How often has a sudden urge to urinate caused you to leak urine?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-sudden-urge',
          display: 'Sudden Urge',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-sudden-urge-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-sudden-urge-1',
            display: 'Seldom',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-sudden-urge-2',
            display: 'About once a week',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-sudden-urge-3',
            display: 'About once a day',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-sudden-urge-4',
            display: 'More than once a day',
          },
        },
      ],
    },
    {
      linkId: 'reach-bathroom',
      type: 'choice',
      text: '6. How often have you leaked urine because you could not reach a bathroom in time?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-reach-bathroom',
          display: 'Reach Bathroom in Time',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-reach-bathroom-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-reach-bathroom-1',
            display: 'Seldom',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-reach-bathroom-2',
            display: 'About once a week',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-reach-bathroom-3',
            display: 'About once a day',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-reach-bathroom-4',
            display: 'More than once a day',
          },
        },
      ],
    },
    {
      linkId: 'protection-type',
      type: 'choice',
      text: '7. On average, what form of protection do you use to protect against wetness during the day?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-protection-type',
          display: 'Protection Type',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-type-0',
            display: 'None',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-type-1',
            display: 'Thin pad or tissue',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-type-2',
            display: 'Medium/regular pad',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-type-3',
            display: 'Large/maxi pad',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-type-4',
            display: 'Absorbant, disposable undergarments',
          },
        },
      ],
    },
    {
      linkId: 'protection-frequency',
      type: 'choice',
      text: '8. On average, how many of these (pads, tissues, disposable undergarments) would you use to protect against wetness during the day?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-protection-frequency',
          display: 'Protection Frequency',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-frequency-0',
            display: 'None',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-frequency-1',
            display: '1 per day or less or only for security',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-frequency-2',
            display: '1 per day and it is usually wet',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-frequency-3',
            display: '2–3 per day',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-protection-frequency-4',
            display: '4 or more per day',
          },
        },
      ],
    },
    {
      linkId: 'activity-changes',
      type: 'choice',
      text: '9. Overall, how often have you needed to change your daily activities because of your urinary incontinence?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-activity-changes',
          display: 'Activity Changes',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-activity-changes-0',
            display: 'Never',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-activity-changes-1',
            display: 'Rarely',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-activity-changes-2',
            display: 'Occasionally',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-activity-changes-3',
            display: 'About half the time',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-activity-changes-4',
            display: 'Most or all of the time',
          },
        },
      ],
    },
    {
      linkId: 'social-impact',
      type: 'choice',
      text: '10. Overall, how big of a social problem (anxiety/embarrassment/avoiding social activities) has your urinary incontinence been for you during the past month?',
      extension: [QUESTIONNAIRE_ITEM_DROPDOWN_EXTENSION],
      code: [
        {
          system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
          code: 'mii-social-impact',
          display: 'Social Impact',
        },
      ],
      answerOption: [
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '0',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 0,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-social-impact-0',
            display: 'No problem',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '1',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 1,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-social-impact-1',
            display: 'Very small problem',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '2',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 2,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-social-impact-2',
            display: 'Small problem',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '3',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 3,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-social-impact-3',
            display: 'Moderate problem',
          },
        },
        {
          extension: [
            {
              url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-optionPrefix',
              valueString: '4',
            },
            {
              url: 'http://hl7.org/fhir/StructureDefinition/ordinalValue',
              valueDecimal: 4,
            },
          ],
          valueCoding: {
            system: 'https://www.seenhealth.org/fhir/Questionnaire/MII',
            code: 'mii-social-impact-4',
            display: 'Big problem',
          },
        },
      ],
    },
  ],
} satisfies Questionnaire
